import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { Row, Col, Form, Input, Skeleton } from 'antd'
import CutOffTime from '../../../CutOffTime'
import { connect, useDispatch, useSelector } from 'react-redux'
import { postData } from '../../../../Actions/Action'
import {
  validateHandlingFeeMarkup,
  validateParcelMaxWeight,
  LableAsLimit,
  checkDigitsAfterDecimal,
  checkValueLimit,
} from '../../../../Utilities/numberValidation'
import LiftGateDelivery from '../../../LiftGateDelivery'
import DeliveryEstimateOptions from '../../../DeliveryEstimateOptions'
import HoldAtTerminal from '../../../HoldAtTerminal'
import Discounts from '../../../Discounts'
import HandlingUnit from '../../../HandlingUnit'
import SaveButton from '../../../SaveButton'
import QuoteServices from './QuoteServices'
import FreightDirectServices, { FREIGHT_DIRECT_SERVICE_FIELDS } from './FreightDirectServices'
import FreightDirectSurcharges from './FreightDirectSurcharges'
import WeightThreshold from '../../../WeightThreshold'
import ErrorManagment from '../../../ErrorManagment'
import NotifyBeforeDelivery from '../../../NotifyBeforeDelivery'
import InsideDeliverySettings from '../../../InsideDeliverySettings'
import LimitedAccessSettings from '../../../LimitedAccessSettings'

const initialState = {
  fedex_freight_economy_label: '',
  fedex_freight_priority_label: '',
  fedex_select_all: false,
  fedex_freight_economy: false,
  fedex_freight_priority: false,
  delivery_estimate_options: 1,
  order_cut_off_time: '',
  fulfillment_offset_days: '',
  all_week_days_select: true,
  week_days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
  hold_at_terminal: false,
  hold_at_terminal_price: '',
  account_discount_price: 60,
  account_discount: 1,
  incentive_discount_percentage: '',
  showDeliveryEstimate: false,
  residentialPickup: false,
  alwaysResidentialDelivery: false,
  autoDetectedResidentialAddresses: false,
  alwaysLiftGatePickup: false,
  alwaysLiftGateDelivery: false,
  offerLiftGateDelivery: false,
  autoDetectedResidentialAddressesLfg: false,
  weight_of_handling_unit: '',
  max_weight_per_handling_unit: '',
  return_rates: false,
  quote_details: 1,
  weight_threshold: '150',
  error_managment:1,
  always_quote_notify: false,
  offer_notify_as_option: false,
  always_inside_delivery: false,
  offer_inside_delivery: false,
  freight_direct_residential_only: false,
  fedex_freight_direct_select_all: false,
  fedex_freight_direct_economy_basic: false,
  fedex_freight_direct_economy_basic_label: '',
  fedex_freight_direct_priority_basic: false,
  fedex_freight_direct_priority_basic_label: '',
  fedex_freight_direct_economy_basic_appointment: false,
  fedex_freight_direct_economy_basic_appointment_label: '',
  fedex_freight_direct_priority_basic_appointment: false,
  fedex_freight_direct_priority_basic_appointment_label: '',
  fedex_freight_direct_priority_standard: false,
  fedex_freight_direct_priority_standard_label: '',
  fedex_freight_direct_priority_premium: false,
  fedex_freight_direct_priority_premium_label: '',
  freight_direct_surcharge_basic: 150,
  freight_direct_surcharge_basic_appointment: 180,
  freight_direct_surcharge_standard: 220,
  freight_direct_surcharge_premium: 280,
}

function QuoteSettingsComponentWwe(props) {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(true)
  const [quoteSettingsState, setQuoteSettingsState] = useState(initialState)
  const dispatch = useDispatch()
  const { thresholdSetting, staffNoteSettings } = useSelector(state => state)
  const [inputEconomy, setInputEconomy] = useState(props?.quoteSettings?.fedex_freight_economy_label);
  const [inputPriority, setInputPriority] = useState(props?.quoteSettings?.fedex_freight_priority_label);
  const isFreightDirect = props?.connectionSettings?.freight_type === 'freight_direct'

  useEffect(() => {
    if (props.quoteSettings !== null && props.quoteSettings !== undefined) {
      getQuoteSettings()
    }
    // eslint-disable-next-line
  }, [props.quoteSettings])

  const radCheck = props.installedAddons.find(
    (add) => add.short_code === 'RAD' && add.is_enabled === 1
  )

  let radStatus = false
  if (radCheck !== undefined) {
    radStatus =
      props?.radPlans?.currentPackage === null
        ? false
        : props?.radPlans?.currentPackage?.status !== 1
        ? false
        : true
  }

  const getQuoteSettings = () => {
    setQuoteSettingsState({
      ...quoteSettingsState,
      ...props.quoteSettings,
    })

    setLoading(false)
  }

  const onFinish = (data) => {
    data = {
      ...quoteSettingsState,
      ...data,
      carrierId: +props.carrierId,
    }
    console.log(data)
    let checkCS = isFreightDirect
      ? FREIGHT_DIRECT_SERVICE_FIELDS.some((field) => data?.[field])
      : data?.fedex_freight_priority || data?.fedex_freight_economy
    if (!data?.hold_at_terminal) {
      data = {
        ...data,
        hold_at_terminal_price: props?.quoteSettings?.hold_at_terminal_price,
      }
    }
    let errormsg = ''

    /*errormsg = validateHandlingFeeMarkup(
			data?.weight_of_handling_unit,
			'Weight of Handling Unit'
		)*/

    if (!isFreightDirect && (data?.offer_limited_access_delivery === true || data?.always_limited_access_delivery === true)) {
			if (data?.limited_access_fee === '' || data?.limited_access_fee === undefined || data?.limited_access_fee === null) {
			  errormsg =
				'Limited access delivery is enabled you must enter limited access delivery fee.'
			} else if (checkDigitsAfterDecimal(data?.limited_access_fee, 2)) {
			  errormsg =
				'Limited access delivery fee only 2 digits are allowed after decimal point.'
			} else if (checkValueLimit(data?.limited_access_fee, 7)) {
			  errormsg =
				'Limited access delivery fee only 7 digits are allowed.'
			}
		}

    if (errormsg === '') {
      errormsg = validateHandlingFeeMarkup(
        data?.handling_free_markup,
        'Handling fee'
      )
    }
    if (!isFreightDirect && errormsg === '') {
      errormsg = validateHandlingFeeMarkup(
        data?.hold_at_terminal_price,
        'Hold at terminal fee'
      )
    }
    if (data?.account_discount === 2) {
      if (
        data?.account_discount_price === null ||
        data?.account_discount_price === ''
      ) {
        errormsg =
          'Promotional discount format should be 10 or 60.5, not allow to put negative value greater than 100. Only 4 digits are allowed after decimal point.'
      }
    } else {
      data.account_discount_price = props?.quoteSettings?.account_discount_price
    }

    if (errormsg === '') {
      errormsg = validateParcelMaxWeight(
        data?.parcel_max_weight,
        data?.weight_threshold,
        thresholdSetting?.parcel_rates
      )
    }

    if (checkCS && errormsg === '') {
      dispatch(
        postData(
          data,
          'GET_QUOTE_SETTINGS',
          'submit_quote_settings',
          props.token
        )
      )
      dispatch(
        postData(
          thresholdSetting,
          'GET_THRESHOLD_SETTINGS',
          'submit_threshold_settings',
          props.token
        )
      )
      dispatch(
				postData(
					staffNoteSettings,
					'GET_STAFFNOTE_SETTINGS',
					'submit_staffnote_settings',
					props.token
				)
			)
    } else {
      errormsg =
        errormsg === ''
          ? 'Please select at least one service option.'
          : errormsg
      dispatch({
        type: 'ALERT_MESSAGE',
        payload: {
          showAlertMessage: false,
        },
      })
      dispatch({
        type: 'ALERT_MESSAGE',
        payload: {
          showAlertMessage: true,
          alertMessage: errormsg,
          alertMessageType: 'error',
        },
      })
    }
  }

  const handleStateChange = useCallback((name, value) => {
    setQuoteSettingsState((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }, [])

  const selectAllQuoteOptions = useCallback(
    (checked) => {
      handleStateChange('fedex_select_all', checked)

      if (checked) {
        handleStateChange('fedex_freight_economy', true)
        handleStateChange('fedex_freight_priority', true)
      } else {
        handleStateChange('fedex_freight_economy', false)
        handleStateChange('fedex_freight_priority', false)
      }
    },
    [handleStateChange]
  )

  const toggleOptions = useCallback(
    (checked, field) => {
      if (checked && quoteSettingsState[field] === true) {
        handleStateChange('fedex_select_all', checked)
      } else {
        handleStateChange('fedex_select_all', false)
      }
    },
    [handleStateChange, quoteSettingsState]
  )

  const selectAllFreightDirectOptions = useCallback(
    (checked) => {
      setQuoteSettingsState((prevState) => {
        const next = { ...prevState, fedex_freight_direct_select_all: checked }
        FREIGHT_DIRECT_SERVICE_FIELDS.forEach((field) => {
          next[field] = checked
        })
        return next
      })
    },
    []
  )

  const toggleFreightDirectOption = useCallback(
    (checked, field) => {
      setQuoteSettingsState((prevState) => {
        const next = { ...prevState, [field]: checked }
        next.fedex_freight_direct_select_all = FREIGHT_DIRECT_SERVICE_FIELDS.every((f) => next[f])
        return next
      })
    },
    []
  )

  return loading || !props.quoteSettings ? (
    <Skeleton active />
  ) : (
    <Fragment>
      <Form
        layout='vertical'
        name='quote_settings_info'
        className='form-wrp'
        size={'large'}
        form={form}
        onFinish={onFinish}
        initialValues={props.quoteSettings}
      >
        <Row gutter={30} className={'mb-3'}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <h4 style={{ fontWeight: 700, fontSize: '16px', marginBottom: 8 }}>FedEx Freight Services</h4>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <label className={'text-black'}>
              The services selected will display in the cart if they are available for the origin and
              destination addresses, and if the FedEx Freight API has been enabled for the corresponding shipping zone.
            </label>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div className={'note-bx'} style={{ marginTop: 8 }}>
              FedEx Freight service marks are owned by FedEx Freight Holding Company, Inc. and are used by permission.
            </div>
          </Col>
        </Row>

        {!isFreightDirect && (
          <>
            <Row gutter={30} className={'mb-3'}>
              <Col
                className='gutter-row'
                style={{ paddingTop: '11px' }}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={6}
              >
                <label className={'text-gray'}>Label As</label>
              </Col>
              <Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={18}>
                <Form.Item className={'mb-0'} name='fedex_freight_economy_label'>
                  <Input
                    name='label_as'
                    placeholder='FedEx Freight® Economy'
                    value={props?.quoteSettings?.fedex_freight_economy_label ?? ''}
                    onKeyDown={LableAsLimit}
                    onChange={(e) => setInputEconomy(e.target.value)}
                    addonAfter={inputEconomy ? <span>{`${inputEconomy?.length}/${20}`}</span> : <span>{`${0}/${20}`}</span>}
                  />
                </Form.Item>
                <div className={'text-gray'}>
                  What the user sees during checkout, e.g. "FedEx Freight® Economy".
                  Leave blank to display the carrier name.
                </div>
              </Col>
            </Row>
            <Row gutter={30} className={'mb-3'}>
              <Col
                className='gutter-row'
                style={{ paddingTop: '11px' }}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={6}
              >
                <label className={'text-gray'}>Label As</label>
              </Col>
              <Col className='gutter-row' xs={24} sm={24} md={24} lg={24} xl={18}>
                <Form.Item className={'mb-0'} name='fedex_freight_priority_label'>
                  <Input
                    name='label_as'
                    placeholder='FedEx Freight® Priority'
                    value={props?.quoteSettings?.fedex_freight_priority_label ?? ''}
                    onKeyDown={LableAsLimit}
                    onChange={(e) => setInputPriority(e.target.value)}
                    addonAfter={inputPriority ? <span>{`${inputPriority?.length}/${20}`}</span> : <span>{`${0}/${20}`}</span>}
                  />
                </Form.Item>
                <div className={'text-gray'}>
                  What the user sees during checkout, e.g. "FedEx Freight® Priority".
                  Leave blank to display the carrier name.
                </div>
              </Col>
            </Row>
          </>
        )}

        {isFreightDirect ? (
          <>
            <FreightDirectServices
              quoteSettingsState={quoteSettingsState}
              handleChange={handleStateChange}
              selectAllFreightDirectOptions={selectAllFreightDirectOptions}
              toggleFreightDirectOption={toggleFreightDirectOption}
              radStatus={radStatus}
            />
            <FreightDirectSurcharges
              quoteSettingsState={quoteSettingsState}
              handleChange={handleStateChange}
            />
          </>
        ) : (
          <QuoteServices
            quoteSettingsState={quoteSettingsState}
            selectAllQuoteOptions={selectAllQuoteOptions}
            handleChange={handleStateChange}
            toggleOptions={toggleOptions}
          />
        )}
        <DeliveryEstimateOptions
          quoteSettingsState={quoteSettingsState}
          setQuoteSettingsState={setQuoteSettingsState}
        />

        <CutOffTime
          quoteSettingsState={quoteSettingsState}
          setQuoteSettingsState={setQuoteSettingsState}
          handleChange={handleStateChange}
        />

        {!isFreightDirect && <><LiftGateDelivery
          quoteSettingsState={quoteSettingsState}
          setQuoteSettingsState={setQuoteSettingsState}
          radStatus={radStatus}
        />

        <NotifyBeforeDelivery
					quoteSettingsState={quoteSettingsState}
			  	setQuoteSettingsState={setQuoteSettingsState}
			  />

        <InsideDeliverySettings
          quoteSettingsState={quoteSettingsState}
          setQuoteSettingsState={setQuoteSettingsState}
        />

        <LimitedAccessSettings
      		quoteSettingsState={quoteSettingsState}
    			setQuoteSettingsState={setQuoteSettingsState}
          islimitedAccessFee = {true}
        />

        <HoldAtTerminal
					quoteSettingsState={quoteSettingsState}
					handleChange={handleStateChange}
				/></>}

        <WeightThreshold
          quoteSettingsState={quoteSettingsState}
          handleStateChange={handleStateChange}
        />

        <HandlingUnit
          quoteSettingsState={quoteSettingsState}
          handleChange={handleStateChange}
          setQuoteSettingsState={setQuoteSettingsState}
        />
          
        <Discounts
          quoteSettingsState={quoteSettingsState}
          handleChange={handleStateChange}
        />

        <ErrorManagment
          quoteSettingsState={quoteSettingsState}
          handleChange={handleStateChange}
        />
        <SaveButton />
      </Form>
    </Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    quoteSettings: state.quoteSettings,
    connectionSettings: state.connectionSettings,
    token: state.token,
    carrierId: state.carrierId,
    plansInfo: state.plansInfo,
    alertMessageType: state.alertMessageType,
    radPlans: state.radPlans,
    installedAddons: state.installedAddons,
  }
}

export default connect(mapStateToProps)(QuoteSettingsComponentWwe)
